import React from 'react';
import { FaUser, FaDesktop, FaHeart } from 'react-icons/fa';
import '../generalPurposeClasses.css';
import T from './Translation';
import useMediaQuery from '../hooks/useMediaQuery';

export const SoulbrunchNumbers = () => {
  const isDesktop = useMediaQuery("(min-width: 1070px)");

  const styles = {
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'stretch',
      padding: '40px 20px',
      maxWidth: '1200px',
      margin: '0 auto',
      gap: isDesktop ? '100px' : '40px',
      flexDirection: isDesktop ? 'row' : 'column',
    },
    section: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      width: '100%',
      maxWidth: '400px',
      minHeight: 'auto',
      justifyContent: 'flex-start',
    },
    iconContainer: {
      width: '140px',
      height: '140px',
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: '30px',
    },
    collaborationIcon: {
      backgroundColor: '#75B798',
      position: 'relative',
    },
    engagementIcon: {
      backgroundColor: '#D97A5B',
    },
    icon: {
      color: 'white',
      fontSize: '50px',
    },
    smallIcon: {
      position: 'absolute',
      right: '30px',
      bottom: '30px',
      color: 'white',
      fontSize: '30px',
    },
    title: {
      fontSize: 'clamp(18px, 3vw, 22px)',
      marginBottom: '25px',
      width: '100%',
      maxWidth: '350px',
      minHeight: '60px',
      lineHeight: 1.4,
      color: '#2B3674',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      padding: '0 10px',
    },
    number: {
      fontSize: 'clamp(36px, 5vw, 48px)',
      fontWeight: 'bold',
      marginBottom: '25px',
      color: '#2B3674',
      height: '70px',
      display: 'flex',
      alignItems: 'center',
    },
    average: {
      fontSize: 'clamp(18px, 3vw, 22px)',
      marginBottom: '10px',
      color: '#2B3674',
      height: '40px',
      display: 'flex',
      alignItems: 'center',
    },
    averageNumber: {
      fontSize: 'clamp(28px, 4vw, 36px)',
      fontWeight: 'bold',
      color: '#2B3674',
      height: '50px',
      display: 'flex',
      alignItems: 'center',
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.section}>
        <div style={{...styles.iconContainer, ...styles.collaborationIcon}}>
          <FaUser style={styles.icon} />
          <FaDesktop style={styles.smallIcon} />
        </div>
        <div style={styles.title}>
          <T obj={{
            en: "Number of people that collaborated on the lyric writing",
            it: "Numero di persone che hanno collaborato alla scrittura dei testi"
          }}/>
        </div>
        <div style={styles.number}>35,456</div>
        <div style={styles.average}>
          <T obj={{
            en: "Average Per Day:",
            it: "Media Giornaliera:"
          }}/>
        </div>
        <div style={styles.averageNumber}>194.81</div>
      </div>

      <div style={styles.section}>
        <div style={{...styles.iconContainer, ...styles.engagementIcon}}>
          <FaHeart style={styles.icon} />
        </div>
        <div style={styles.title}>
          <T obj={{
            en: "Live engagement (likes):",
            it: "Coinvolgimento dal vivo (mi piace):"
          }}/>
        </div>
        <div style={styles.number}>240,180</div>
        <div style={styles.average}>
          <T obj={{
            en: "Average engagement (likes):",
            it: "Coinvolgimento medio (mi piace):"
          }}/>
        </div>
        <div style={styles.averageNumber}>1,319.67</div>
      </div>
    </div>
  );
};
